import React from 'react'
import {compose} from 'recompose'
import CustomSelect from '../../elements/Select/CustomSelect'
import withData from '../../elements/Select/withData'

const StandardTypeSelect = compose(
  withData({
    data: [
      {
        key: 'Current',
        value: 'Current',
      },
      {
        key: 'Deprecated',
        value: 'Deprecated',
      },
    ],
  }),
)(CustomSelect)

export default StandardTypeSelect
